import { Loader } from "@googlemaps/js-api-loader";
import { MarkerManager } from "@googlemaps/markermanager";
import { } from "google-maps";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import LogisticLoadRestModel from "../../models/rest/logistic/logisticLoadRestModel";
import VehicleRestModel from "../../models/rest/vehicle/vehicleRestModel";
import InfoWindow from "./info-window.vue";
import LogisticLoadInfoWindow from "./logistic-load-info-window.vue";


@Component({
    components: {
        "info-window": InfoWindow,
        "logistic-load-info-window": LogisticLoadInfoWindow
    }
})

export default class Map extends Vue {
    map: google.maps.Map | undefined;
    showInfoWindow = false;
    showLogiscticLoadInfoWindow = false;
    currentVehicleMarkers: any = {};
    currentLogisticLoadMarkers: any = {};
    infoWindowElement = document.getElementById("info-window") as HTMLElement;
    logisticLoadInfoWindowElement = document.getElementById("logistic-load-info-window") as HTMLElement;
    vMarkers: any[] = [];
    previewVehicleKey: number | null = null;
    currentInfoWindow: any = {};
    directionsService: google.maps.DirectionsService | undefined;
    directionsRenderer: google.maps.DirectionsRenderer | undefined;
    waypts: google.maps.DirectionsWaypoint[] = [];
    computedDistance: string = "";
    computedTime: string = "";
    interval: number | undefined = 0;

    loader = new Loader({
        apiKey: this.googleMapsApiKey,
        libraries: ["places"]
    });

    get vehicleModifiedTime(): string {
        return this.$store.direct.state.vehicle.vehicleModifiedTime;
    }

    get googleMapsApiKey(): string {
        return this.$store.direct.state.auth.googleMapsApiKey;
    }

    get showInfoDialog(): boolean {
        return this.$store.direct.state.vehicle.showVehicleMapInfoDialog;
    }

    get infoDialogMessage(): string {
        return this.$store.direct.state.vehicle.vehicleMapInfoDialogMessage;
    }

    get vehicleMapList(): VehicleRestModel[] {
        return this.$store.direct.state.vehicle.vehicleMapList;
    }

    get logisticLoadMapList(): LogisticLoadRestModel[] {
        return this.$store.direct.state.logistic.logisticLoadMapList;
    }

    get vehicle(): VehicleRestModel {
        return this.$store.direct.state.vehicle.vehicle;
    }

    get logisticLoad(): LogisticLoadRestModel {
        return this.$store.direct.state.logistic.logisticLoad;
    }

    @Watch("vehicleModifiedTime")
    async vehicleModifiedTimeChanged() {
        await this.$store.direct.dispatch.vehicle.loadVehicleMapList();
        await this.$store.direct.dispatch.logistic.loadLogisticLoadMapList();
        this.initialMarkers();
    }

    async created() {
        await this.$store.direct.dispatch.vehicle.loadVehicleMapList();
        await this.$store.direct.dispatch.logistic.loadLogisticLoadMapList();
        await this.loadMap()
        this.interval = setInterval(async () => await this.$store.direct.dispatch.vehicle.checkChanges(), 30000)
    }

    destroyed() {
        clearInterval(this.interval);
        this.interval = undefined;
    }

    async holdOnOffChildClick(vehicleId: number) {
        const vehicleIcon = await this.getVehicleIcon(this.vehicle)
        const vehicleMarker = await this.currentVehicleMarkers[vehicleId]
        await vehicleMarker.marker.setIcon(vehicleIcon)
    }

    async unavailableChildClick(vehicleId: number) {
        await this.currentVehicleMarkers[vehicleId].infoWindow.close();
        await this.currentVehicleMarkers[vehicleId].marker.setMap(null);
        this.currentVehicleMarkers[vehicleId].marker = null;
        delete this.currentVehicleMarkers[vehicleId]
    }

    async getDirectionClick(waystations: any[], avoidHighways: boolean, avoidTolls: boolean) {
        this.waypts = [];
        waystations.forEach((station: any) => {
            let latLng: google.maps.LatLng;

            if (station.fullPlaceName.lat == undefined) {
                latLng = new google.maps.LatLng(station.lat, station.lng)
            }
            else {
                latLng = new google.maps.LatLng(station.fullPlaceName.lat, station.fullPlaceName.lng)
            }
            this.waypts.push({ location: latLng })
        })

        const request: google.maps.DirectionsRequest = {
            origin: this.waypts[0] as google.maps.LatLng,
            destination: this.waypts[this.waypts.length - 1] as google.maps.LatLng,
            waypoints: this.waypts,
            travelMode: google.maps.TravelMode.DRIVING,
            avoidHighways: avoidHighways,
            avoidTolls: avoidTolls,
        };

        this.directionsService?.route(request, (result: google.maps.DirectionsResult, status: google.maps.DirectionsStatus) => {
            if (status == google.maps.DirectionsStatus.OK) {
                this.directionsRenderer?.setDirections(result);
                this.directionsRenderer?.setOptions({
                    markerOptions: {
                        visible: false
                    } as google.maps.MarkerOptions
                });
                this.computeTotalDistance(result);
                this.computeTotalTime(result);
            }
        })
    }

    computeTotalDistance(result: google.maps.DirectionsResult) {
        let total = 0;
        const myroute = result.routes[0];
        for (let i = 0; i < myroute.legs.length; i++) {
            total += myroute.legs[i].distance.value;
        }
        total = Math.round(total / 1000);
        this.computedDistance = total + " km";
    }

    computeTotalTime(result: google.maps.DirectionsResult) {
        let hours = 0;
        let minutes = 0;
        let totalTime = 0;
        const myroute = result.routes[0];
        for (let i = 0; i < myroute.legs.length; i++) {
            totalTime += myroute.legs[i].duration.value;
        }
        minutes = Math.round(totalTime / 60);
        hours = Math.floor(minutes / 60);
        minutes = (minutes % 60);
        this.computedTime = hours + ' h, ' + minutes + ' min'
    }

    vehicleExist(vehicle: any, vehicleCollection: any) {
        const vehicleId = vehicle.id.toString()
        const hasVehicle = Object.keys(vehicleCollection).includes(vehicleId)
        if (hasVehicle) {
            return vehicleCollection[parseInt(vehicleId)];
        }
        else {
            return null;
        }
    }

    logisticLoadExist(logisticLoad: any, logisticLoadCollection: any) {
        const logisticLoadId = logisticLoad.id.toString()
        const hasLogisticLoad = Object.keys(logisticLoadCollection).includes(logisticLoadId)
        if (hasLogisticLoad) {
            return logisticLoadCollection[parseInt(logisticLoadId)];
        }
        else {
            return null;
        }
    }


    async setupMarkers(vehicleMarkers: any, logisticLoadMarkers: any) {
        let i = 0
        const tempVehicleMarkers = [] as any[];
        Object.keys(this.currentVehicleMarkers).forEach(async key => {
            const currentVehicle = this.currentVehicleMarkers[parseInt(key)];
            const vehicleExist = this.vehicleExist(currentVehicle, vehicleMarkers)

            if (vehicleExist == null) {
                currentVehicle.marker.setMap(null);
                currentVehicle.marker = null;
                delete this.currentVehicleMarkers[parseInt(key)]
            }
        })

        Object.keys(vehicleMarkers).forEach(async key => {
            const vehicle = vehicleMarkers[parseInt(key)];
            const pos = new google.maps.LatLng(vehicle.lat, vehicle.lng);

            let markerImage: any;
            try {
                markerImage = await this.getVehicleIcon(vehicle);
                if (!markerImage) {
                    markerImage = null;
                }
            } catch (error) {
                console.error(`Błąd przy pobieraniu ikony dla pojazdu ${vehicle.id}:`, error);
                markerImage = null;
            }

            const title = `${vehicle.registrationNumber} (${vehicle.palletCount}) Available from: ${vehicle.availableFrom}`;
            let marker: any = null;
            const returnedVehicle = this.vehicleExist(vehicle, this.currentVehicleMarkers)
            const oldMarker = returnedVehicle != null ? returnedVehicle as VehicleRestModel : null;

            if (oldMarker != null) {
                marker = oldMarker.marker;
                marker.setPosition(pos);
                marker.setIcon(markerImage);
                marker.setTitle(title);
            }
            else {
                const markerOptions =
                {
                    title: title,
                    icon: markerImage,
                    position: pos,
                    map: this.map
                };
                marker = new google.maps.Marker(markerOptions);

                vehicle.marker = marker;
                const infoWindow = new google.maps.InfoWindow();
                this.createMyInfoWindow(infoWindow, marker, vehicle, 'vehicle');
                vehicle.infoWindow = infoWindow;
                this.currentVehicleMarkers[vehicle.id] = vehicle
            }
            i++
        })

        let ix = 0
        Object.keys(this.currentLogisticLoadMarkers).forEach(async key => {
            const currentLogisticLoad = this.currentLogisticLoadMarkers[parseInt(key)];
            const logisticLoadExist = this.logisticLoadExist(currentLogisticLoad, logisticLoadMarkers)

            if (logisticLoadExist == null) {
                currentLogisticLoad.marker.setMap(null);
                currentLogisticLoad.marker = null;
                delete this.currentLogisticLoadMarkers[parseInt(key)]
            }
        })

        const tempLogisticLoadMarkers = [] as any[];
        Object.keys(logisticLoadMarkers).forEach(async key => {
            const logisticLoad = logisticLoadMarkers[parseInt(key)];
            const pos = new google.maps.LatLng(logisticLoad.pickupLat, logisticLoad.pickupLng);

            let markerImage: any;
            try {
                markerImage = await this.getLogisticLoadIcon(logisticLoad);
                if (!markerImage) {
                    markerImage = null;
                }
            } catch (error) {
                console.error(`Błąd przy pobieraniu ikony dla pojazdu ${logisticLoad.id}:`, error);
                markerImage = null;
            }

            let marker: any = null;
            const returnedLogisticLoad = this.vehicleExist(logisticLoad, this.currentLogisticLoadMarkers)
            const oldMarker = returnedLogisticLoad != null ? returnedLogisticLoad as LogisticLoadRestModel : null;

            if (oldMarker != null) {
                marker = oldMarker.marker;
                marker.setPosition(pos);
                marker.setIcon(markerImage);
            }
            else {
                const markerOptions =
                {
                    icon: markerImage,
                    position: pos,
                    map: this.map
                };
                marker = new google.maps.Marker(markerOptions);

                logisticLoad.marker = marker;
                const infoWindow = new google.maps.InfoWindow();
                this.createMyInfoWindow(infoWindow, marker, logisticLoad, 'logisticLoad');
                logisticLoad.infoWindow = infoWindow;
                this.currentLogisticLoadMarkers[logisticLoad.id] = logisticLoad
            }
            ix++
        })
    }

    createMyInfoWindow(infoWindow: any, marker: any, object: any, objectType: string) {
        if (objectType == 'vehicle') {
            const that = this;
            google.maps.event.clearListeners(marker, 'click');
            google.maps.event.addListener(marker, 'click', async function () {
                infoWindow.close();
                const currentInfoWindowElement = document.getElementById("info-window") as HTMLElement;

                if (Object.keys(that.currentInfoWindow).length != 0) {
                    that.currentInfoWindow.close();
                }

                if (that.infoWindowElement == undefined) {
                    that.infoWindowElement = currentInfoWindowElement;
                }

                await that.$store.direct.dispatch.vehicle.loadVehicle({ id: object.id });
                that.showInfoWindow = true;
                infoWindow.setContent(that.infoWindowElement);
                infoWindow.open(that.map, marker);
                that.currentInfoWindow = infoWindow
            });
        }
        else if (objectType == 'logisticLoad') {
            const that = this;
            google.maps.event.clearListeners(marker, 'click');
            google.maps.event.addListener(marker, 'click', async function () {
                infoWindow.close();
                const currentInfoWindowElement = document.getElementById("logistic-load-info-window") as HTMLElement;

                if (Object.keys(that.currentInfoWindow).length != 0) {
                    that.currentInfoWindow.close();
                }

                if (that.logisticLoadInfoWindowElement == undefined) {
                    that.logisticLoadInfoWindowElement = currentInfoWindowElement;
                }

                await that.$store.direct.dispatch.logistic.loadLogisticLoad({ id: object.id });
                that.showLogiscticLoadInfoWindow = true;
                infoWindow.setContent(that.logisticLoadInfoWindowElement);
                infoWindow.open(that.map, marker);
                that.currentInfoWindow = infoWindow
            });
        }
    }

    spreadMarkers(): void {
        if (!this.map) return;
        const overlay = new google.maps.OverlayView();
        overlay.onAdd = function () { /* intentionally empty */ };
        overlay.draw = function () { /* intentionally empty */ };
        overlay.onRemove = function () { /* intentionally empty */ };
        overlay.setMap(this.map);

        google.maps.event.addListenerOnce(this.map, 'idle', () => {
            const projection = overlay.getProjection();
            if (!projection) return;

            const allMarkers: google.maps.Marker[] = [];

            Object.keys(this.currentVehicleMarkers).forEach(key => {
                const marker = this.currentVehicleMarkers[key].marker;
                if (marker) {
                    if (!marker.originalPosition) {
                        marker.originalPosition = marker.getPosition();
                    } else {
                        marker.setPosition(marker.originalPosition);
                    }
                    allMarkers.push(marker);
                }
            });

            Object.keys(this.currentLogisticLoadMarkers).forEach(key => {
                const marker = this.currentLogisticLoadMarkers[key].marker;
                if (marker) {
                    if (!marker.originalPosition) {
                        marker.originalPosition = marker.getPosition();
                    } else {
                        marker.setPosition(marker.originalPosition);
                    }
                    allMarkers.push(marker);
                }
            });

            interface Cluster {
                markers: google.maps.Marker[];
                center: google.maps.Point;
            }
            const clusters: Cluster[] = [];
            const tolerance = 25; // szerokość odsunięcia ikon

            allMarkers.forEach(marker => {
                const pos = marker.getPosition();
                if (!pos) return;
                const pixelPos = projection.fromLatLngToDivPixel(pos);
                let addedToCluster = false;

                for (const cluster of clusters) {
                    const dx = pixelPos.x - cluster.center.x;
                    const dy = pixelPos.y - cluster.center.y;
                    const distance = Math.sqrt(dx * dx + dy * dy);
                    if (distance < tolerance) {
                        cluster.markers.push(marker);
                        const total = cluster.markers.length;
                        cluster.center.x = (cluster.center.x * (total - 1) + pixelPos.x) / total;
                        cluster.center.y = (cluster.center.y * (total - 1) + pixelPos.y) / total;
                        addedToCluster = true;
                        break;
                    }
                }
                if (!addedToCluster) {
                    clusters.push({
                        markers: [marker],
                        center: new google.maps.Point(pixelPos.x, pixelPos.y)
                    });
                }
            });

            clusters.forEach(cluster => {
                if (cluster.markers.length > 1) {
                    const n = cluster.markers.length;
                    const offsetRadius = tolerance;
                    cluster.markers.forEach((marker, index) => {
                        const angle = (2 * Math.PI * index) / n;
                        const newX = cluster.center.x + offsetRadius * Math.cos(angle);
                        const newY = cluster.center.y + offsetRadius * Math.sin(angle);
                        const newLatLng = projection.fromDivPixelToLatLng(new google.maps.Point(newX, newY));
                        marker.setPosition(newLatLng);
                    });
                }
            });
        });
    }

    async initialMarkers() {
        const vehicleMarkers: any = {};
        await this.vehicleMapList.forEach((item: any) => {
            vehicleMarkers[item.id] = {
                id: item.id,
                availableFrom: item.availableFrom,
                isSpecial: item.isSpecial,
                lat: item.lat,
                lng: item.lng,
                palletCount: item.palletCount,
                registrationNumber: item.registrationNumber,
                vehicleTypeId: item.vehicleTypeId,
                vehicleState: item.vehicleState,
            }
        });

        const logisticLoadMarkers: any = {};
        await this.logisticLoadMapList.forEach((item: any) => {
            logisticLoadMarkers[item.id] = {
                id: item.id,
                pickupLat: item.pickupLat,
                pickupLng: item.pickupLng,
                loadTypeId: item.loadTypeId,
                loadStateId: item.loadStateId,
            }
        });
        await this.setupMarkers(vehicleMarkers, logisticLoadMarkers);
        this.spreadMarkers();
    }

    async loadMap() {
        await this.loader.load().then(async () => {
            this.map = new google.maps.Map(document.getElementById("map") as HTMLElement, {
                center: {
                    lat: 50,
                    lng: 15
                },
                zoom: 5,
                mapTypeControl: true
            });
            await this.initialMarkers()
            this.map.addListener('idle', () => {
                this.spreadMarkers();
            });

            this.directionsService = new google.maps.DirectionsService();
            this.directionsRenderer = new google.maps.DirectionsRenderer();
            this.directionsRenderer.setMap(this.map);
        })
    }

    get vehicleIcons(): any {
        return this.$store.direct.state.common.vehicleIcons;
    }

    async getVehicleIcon(vehicle: VehicleRestModel) {
        const vehicleTypeId = vehicle.vehicleTypeId;
        const vehicleState = vehicle.vehicleState;
        const iconKey = vehicleTypeId + '_' + vehicleState;
        const icon = this.vehicleIcons[iconKey]

        if (icon == undefined) {
            await this.$store.direct.dispatch.common.loadVehicleIcon({ typeId: vehicleTypeId, state: vehicleState, key: iconKey });
        }

        return this.vehicleIcons[iconKey]
    }

    get logisticLoadIcons(): any {
        return this.$store.direct.state.logistic.logisticLoadIcons;
    }

    async getLogisticLoadIcon(logisticLoad: LogisticLoadRestModel) {
        const logisticLoadTypeId = logisticLoad.loadTypeId;
        const logisticLoadStateId = logisticLoad.loadStateId;
        const iconKey = logisticLoadTypeId + '_' + logisticLoadStateId;
        const icon = this.logisticLoadIcons[iconKey];

        if (icon == undefined) {
            await this.$store.direct.dispatch.logistic.loadLogisticLoadIcon({ typeId: logisticLoadTypeId, stateId: logisticLoadStateId });
        }

        return this.logisticLoadIcons[iconKey];
    }
}
